module.exports = __webpack_public_path__ + "static/media/material-rose-gold.27e4f18e.svg";